(function ($) {
    $(document).ready(function () {
        pressAwardsCarousel();
    });

    function pressAwardsCarousel() {
        var wraps = $('.section.press_awards.layout_carousel');
        wraps.each(function () {
            var wrap = $(this).find('.slider_inner_wrap');
            if (wrap.length > 0) {
                var countEl = wrap.find('.article_wrap').length;
                var window_width = $(window).width();
                var hasCarousel = false;

                if(window_width < 500){
                    if(countEl > 1){
                        hasCarousel = true;
                    }
                } else if(window_width < 769){
                    if(countEl > 2){
                        hasCarousel = true;
                    }
                } else if(window_width < 1501){
                    if(countEl > 3){
                        hasCarousel = true;
                    }
                } else {
                    if(countEl > 4 ){
                        hasCarousel = true;
                    }
                }

                wrap.on("init", function () {
                    $(this).closest('.section.press_awards.layout_carousel').addClass('carousel-loaded');
                    lazyLoadInstance.update();
                });

                if(hasCarousel){
                    wrap.slick({
                        rows:0,
                        arrows: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        rtl: $('html').attr('dir') === 'rtl',
                        responsive: [
                            {
                                breakpoint: 1501,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                }
                            },
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 500,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    adaptiveHeight: true,
                                    centerMode:true
                                }
                            },
                        ]
                    });
                }

            }
        });
    }
})(jQuery);